import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen from-gray-900 to-gray-800 flex items-center justify-center px-4" }
const _hoisted_2 = { class: "w-full max-w-3xl" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "animate-spin h-6 w-6 border-2 border-white border-t-transparent rounded-full"
}
const _hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 mr-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_10 = ["d"]
const _hoisted_11 = {
  key: 0,
  class: "mt-3 bg-white bg-opacity-5 rounded-lg p-4 space-y-3"
}
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "mt-4 flex justify-center items-center space-x-6" }
const _hoisted_16 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_17 = {
  key: 1,
  class: "text-gray-400 flex items-center"
}
const _hoisted_18 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_19 = { class: "space-y-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "flex items-center space-x-3" }
const _hoisted_22 = { class: "text-gray-300" }
const _hoisted_23 = {
  key: 0,
  class: "mt-1 ml-7 flex flex-wrap gap-2"
}
const _hoisted_24 = { class: "flex items-center space-x-4" }
const _hoisted_25 = { class: "text-sm text-gray-500" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "mt-12 bg-white bg-opacity-5 rounded-2xl p-6 backdrop-blur-sm"
}
const _hoisted_29 = { class: "text-gray-400 text-sm mb-2 capitalize" }
const _hoisted_30 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_31 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_32 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 mr-2 text-green-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_33 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 mr-2 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_34 = { class: "text-gray-300" }
const _hoisted_35 = {
  key: 2,
  class: "text-2xl font-bold text-white"
}
const _hoisted_36 = {
  key: 3,
  class: "text-2xl font-bold text-white"
}
const _hoisted_37 = {
  key: 2,
  class: "mt-6 text-red-400 text-center"
}

import { ref, onMounted, computed } from 'vue'
import { useOrgStore } from '@/stores/org'

interface SearchHistoryItem {
  query: string;
  timestamp: Date;
  responseTime: number;
  result: any;
  metadata?: Record<string, string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MySearchView',
  setup(__props) {

const searchQuery = ref('')
const isLoading = ref(false)
const error = ref('')
const searchResult = ref<any>(null)
const showMetadata = ref(false)
const metadataPairs = ref<Array<{key: string, value: string}>>([{key: '', value: ''}])

const searchHistory = ref<Array<SearchHistoryItem>>([])
const responseTime = ref<number>(0)
const orgStore = useOrgStore()

const averageResponseTime = computed(() => {
  if (searchHistory.value.length === 0) return 0
  const total = searchHistory.value.reduce((sum, item) => sum + item.responseTime, 0)
  return Math.round(total / searchHistory.value.length)
})

const metadataObject = computed(() => {
  const obj: Record<string, string> = {}
  metadataPairs.value.forEach(pair => {
    if (pair.key.trim() && pair.value.trim()) {
      obj[pair.key.trim()] = pair.value.trim()
    }
  })
  return Object.keys(obj).length > 0 ? obj : null
})

const addMetadataPair = () => {
  metadataPairs.value.push({key: '', value: ''})
}

const removeMetadataPair = (index: number) => {
  if (metadataPairs.value.length > 1) {
    metadataPairs.value.splice(index, 1)
  } else {
    metadataPairs.value[0] = {key: '', value: ''}
  }
}

onMounted(async () => {
  await orgStore.fetchOrgData()
})

const handleSearch = async (queryOverride?: string, metadataOverride?: Record<string, string>) => {
  const queryToUse = queryOverride || searchQuery.value.trim()
  if (!queryToUse) return
  
  // Update the search input and metadata when using a history item
  if (queryOverride) {
    searchQuery.value = queryOverride
    if (metadataOverride) {
      // Restore metadata pairs from history
      metadataPairs.value = Object.entries(metadataOverride).map(([key, value]) => ({ key, value }))
      if (metadataPairs.value.length === 0) {
        metadataPairs.value = [{key: '', value: ''}]
      }
      showMetadata.value = true
    } else {
      // Clear metadata if none in history item
      metadataPairs.value = [{key: '', value: ''}]
    }
  }
  if (!orgStore.orgData?.id) {
    error.value = 'Please set up your organization first'
    return
  }
  
  isLoading.value = true
  error.value = ''
  searchResult.value = null
  responseTime.value = 0
  
  const startTime = performance.now()

  try {
    const isDev = process.env.NODE_ENV === 'development'
    console.log('[DEV] isDev', isDev) 
    const baseUrl = isDev 
      ? 'http://127.0.0.1:5001/search-plus-3bf60/australia-southeast1/queryV2' 
      : 'https://australia-southeast1-search-plus-3bf60.cloudfunctions.net/queryV2'

    const queryParams = new URLSearchParams({
      q: queryToUse,
      org_id: orgStore.orgData.id,
      test: 'true'
    })

    // Add metadata if provided - use override from history or current metadataObject
    const metadataToUse = metadataOverride || metadataObject.value
    if (metadataToUse) {
      queryParams.append('metadata', JSON.stringify(metadataToUse))
    }

    const response = await fetch(`${baseUrl}?${queryParams}`)
    const data = await response.json()
    
    const endTime = performance.now()
    responseTime.value = Math.round(endTime - startTime)
    
    if (data.success) {
      searchResult.value = data
      // Add to search history - use the metadata that was actually sent
      searchHistory.value.unshift({
        query: queryToUse,
        timestamp: new Date(),
        responseTime: responseTime.value,
        result: data,
        metadata: metadataToUse || undefined
      })
    } else {
      error.value = 'Sorry, we couldn\'t find any recommendations. Please try a different search.'
    }
  } catch (err) {
    error.value = 'Something went wrong. Please try again later.'
    console.error('Search error:', err)
  } finally {
    isLoading.value = false
  }
}

const getProductUrl = (productUrl: string) => {
  const storeName = orgStore.orgData?.keys?.shopify?.storeName
  if (!storeName) {
    return productUrl
  }
  // Remove any leading slash
  const cleanUrl = productUrl.replace(/^\//, '')
  return `https://${storeName}.myshopify.com/${cleanUrl}`
}

const viewSearchResult = (item: SearchHistoryItem) => {
  searchQuery.value = item.query
  searchResult.value = item.result
  responseTime.value = item.responseTime
  error.value = ''
  // Restore metadata if present
  if (item.metadata) {
    metadataPairs.value = Object.entries(item.metadata).map(([key, value]) => ({ key, value }))
    if (metadataPairs.value.length === 0) {
      metadataPairs.value = [{key: '', value: ''}]
    }
    showMetadata.value = true
  } else {
    metadataPairs.value = [{key: '', value: ''}]
  }
}

const deleteSearchItem = (index: number) => {
  searchHistory.value = searchHistory.value.filter((_, i) => i !== index)
}

const formatKey = (key: string): string => {
  return key
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

const resetSearch = () => {
  searchQuery.value = ''
  searchResult.value = null
  error.value = ''
  responseTime.value = 0
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-center mb-12" }, [
        _createElementVNode("h1", { class: "text-4xl font-bold text-white mb-4" }, "Test Your Search"),
        _createElementVNode("p", { class: "text-gray-400 text-lg" }, "Use this page to test your search configuration")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Enter your search query...",
          class: "w-full px-6 py-4 bg-white bg-opacity-10 rounded-xl text-white placeholder-gray-400 border border-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none transition-all duration-300 text-lg backdrop-blur-sm",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(() => handleSearch(), ["enter"])),
          disabled: isLoading.value
        }, null, 40, _hoisted_4), [
          [_vModelText, searchQuery.value]
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = () => handleSearch()),
          class: "absolute right-3 top-1/2 transform -translate-y-1/2 bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-lg transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed",
          disabled: isLoading.value
        }, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[4] || (_cache[4] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                }, null, -1)
              ])))
        ], 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showMetadata.value = !showMetadata.value)),
          class: "text-sm text-gray-400 hover:text-gray-300 transition-colors flex items-center"
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_9, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: showMetadata.value ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'
            }, null, 8, _hoisted_10)
          ])),
          _createTextVNode(" " + _toDisplayString(showMetadata.value ? 'Hide' : 'Add') + " Metadata ", 1)
        ]),
        (showMetadata.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metadataPairs.value, (pair, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex items-center gap-2"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((pair.key) = $event),
                    placeholder: "Key",
                    class: "flex-1 px-3 py-2 bg-white bg-opacity-10 rounded-lg text-white placeholder-gray-400 border border-gray-700 focus:border-blue-500 focus:outline-none text-sm"
                  }, null, 8, _hoisted_12), [
                    [_vModelText, pair.key]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((pair.value) = $event),
                    placeholder: "Value",
                    class: "flex-1 px-3 py-2 bg-white bg-opacity-10 rounded-lg text-white placeholder-gray-400 border border-gray-700 focus:border-blue-500 focus:outline-none text-sm"
                  }, null, 8, _hoisted_13), [
                    [_vModelText, pair.value]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (removeMetadataPair(index)),
                    class: "p-2 text-gray-400 hover:text-red-400 transition-colors",
                    title: "Remove"
                  }, _cache[5] || (_cache[5] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "h-5 w-5",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]), 8, _hoisted_14)
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: addMetadataPair,
                class: "text-sm text-blue-400 hover:text-blue-300 transition-colors flex items-center"
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-4 w-4 mr-1",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 4v16m8-8H4"
                  })
                ], -1),
                _createTextVNode(" Add Metadata Field ")
              ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        (responseTime.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Response time: " + _toDisplayString(responseTime.value) + "ms ", 1))
          : _createCommentVNode("", true),
        (searchHistory.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _cache[7] || (_cache[7] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4 mr-1",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                })
              ], -1)),
              _createTextVNode(" Avg. response time: " + _toDisplayString(averageResponseTime.value) + "ms ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (searchHistory.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-gray-400 text-sm mb-2" }, "Recent Searches", -1)),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchHistory.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex items-center justify-between bg-white bg-opacity-5 rounded-lg p-3 hover:bg-opacity-10 transition-all group"
                }, [
                  _createElementVNode("div", {
                    class: "flex flex-col flex-grow cursor-pointer",
                    onClick: ($event: any) => (handleSearch(item.query, item.metadata))
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[8] || (_cache[8] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4 text-gray-400",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(item.query), 1)
                    ]),
                    (item.metadata && Object.keys(item.metadata).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.metadata, (value, key) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: key,
                              class: "text-xs px-2 py-0.5 bg-blue-500 bg-opacity-20 text-blue-300 rounded"
                            }, _toDisplayString(key) + ": " + _toDisplayString(value), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_20),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(item.responseTime) + "ms ", 1),
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (viewSearchResult(item)), ["stop"]),
                      class: "p-1 hover:bg-white hover:bg-opacity-10 rounded transition-colors",
                      title: "View result"
                    }, _cache[9] || (_cache[9] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4 text-gray-400 hover:text-blue-400",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        })
                      ], -1)
                    ]), 8, _hoisted_26),
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (deleteSearchItem(index)), ["stop"]),
                      class: "p-1 hover:bg-white hover:bg-opacity-10 rounded transition-colors",
                      title: "Remove from history"
                    }, _cache[10] || (_cache[10] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4 text-gray-400 hover:text-red-400",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]), 8, _hoisted_27)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (searchResult.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResult.value.data, (value, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "mb-6"
              }, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(formatKey(String(key))), 1),
                (Array.isArray(value))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "flex items-start text-gray-300"
                        }, [
                          _cache[12] || (_cache[12] = _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-6 w-6 mr-3 text-green-500 flex-shrink-0",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M5 13l4 4L19 7"
                            })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(item), 1)
                        ]))
                      }), 128))
                    ]))
                  : (typeof value === 'boolean')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        value
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _cache[13] || (_cache[13] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M5 13l4 4L19 7"
                              }, null, -1)
                            ])))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_33, _cache[14] || (_cache[14] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M6 18L18 6M6 6l12 12"
                              }, null, -1)
                            ]))),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(value ? 'Yes' : 'No'), 1)
                      ]))
                    : (typeof value === 'number')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(value), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(value), 1))
              ]))
            }), 128)),
            _createElementVNode("button", {
              onClick: resetSearch,
              class: "mt-8 text-gray-400 hover:text-white transition-colors duration-300 flex items-center mx-auto"
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5 mr-2",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                })
              ], -1),
              _createTextVNode(" Try another search ")
            ]))
          ]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})